import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDisconnect, useActiveWallet } from "thirdweb/react";

export default function TaasSignoutPage() {
    const { disconnect } = useDisconnect();
    const wallet = useActiveWallet();
    const { projectId } = useParams();

    useEffect(() => {
        walletLogout();
    }, []);

    const walletLogout = async () => {
        try {
            if (wallet) {
                await disconnect(wallet);
            }
        } catch (error) {
            console.error("Error in disconnecting wallet", error);
        }
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = `/token-app/${projectId}/login`;
    };

    return null;
}
